/* import __COLOCATED_TEMPLATE__ from './list-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();